import React from "react";
type DividerVariant = "strata" | "ochre" | "yellow" | "gold";
type SectionDividerProps = {
  variant: DividerVariant;
  from: string;
  to: string;
  flip?: boolean;
};
const STRATA_URL = "https://cdn.magicpatterns.com/uploads/tXoEfyRWYPVxQuovkpqsXL/earth-strata-full.png";
const bandColours: Record<Exclude<DividerVariant, "strata">, string> = {
  ochre: "#DB5C29",
  yellow: "#FFCF53",
  gold: "#D58D33"
};

/* Hand-painted style band, echoing the brush-stroke panels in the Big Yellow brand kit. */
const BAND_PATH = "M0,16 C90,12 170,18 260,15 C380,11 470,19 590,16 C700,13 790,12 900,15 C1010,18 1100,11 1220,13 C1310,15 1380,11 1440,12 L1440,64 C1370,68 1300,63 1200,66 C1090,69 990,71 880,68 C770,65 660,70 550,69 C440,68 350,64 240,67 C150,70 70,66 0,68 Z";
export function SectionDivider({
  variant,
  from,
  to,
  flip = false
}: SectionDividerProps) {
  if (variant === "strata") {
    return <div aria-hidden="true" className="relative h-12 w-full sm:h-16" style={{
      backgroundColor: from
    }} data-id="element-87" data-mp="2ghbzhehylma1">
        <div className="absolute inset-0 bg-repeat-x" style={{
        backgroundImage: `url(${STRATA_URL})`,
        backgroundSize: "auto 100%",
        backgroundPosition: "center"
      }} data-id="element-88" data-mp="3aovxgjblca5h" />
      </div>;
  }
  return <div aria-hidden="true" className="relative h-12 w-full overflow-hidden sm:h-16 lg:h-20" data-id="element-89" data-mp="31qbmk4c9v4rt">
      <div className="absolute inset-x-0 top-0 h-1/2" style={{
      backgroundColor: from
    }} data-id="element-90" data-mp="36petxvfq5n2y" />
      <div className="absolute inset-x-0 bottom-0 h-1/2" style={{
      backgroundColor: to
    }} data-id="element-91" data-mp="3udobum9thqot" />
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className={`absolute inset-0 h-full w-full ${flip ? "-scale-x-100" : ""}`} data-id="element-92" data-mp="2andfzn4wrox">
        <path d={BAND_PATH} fill={bandColours[variant]} data-id="element-93" data-mp="3kf8gg73rbv9i" />
      </svg>
    </div>;
}